// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
export type SummaryBeneficiaryv2Fragment = { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string, kind: Types.SummaryBeneficiaryKindv2, badgeText?: string | null, additionalContext: Array<string | null>, ownershipPercentage: string, displayType: string };

export const Operations = {
  Fragment: {
    SummaryBeneficiaryv2: 'SummaryBeneficiaryv2' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const SummaryBeneficiaryv2FragmentDoc = gql`
    fragment SummaryBeneficiaryv2 on SummaryBeneficiaryv2 {
  id
  displayName
  kind
  badgeText
  additionalContext
  ownershipPercentage
  displayType
}
    `;